export default [
    { id: 'Lines', label: 'Lines', parent: '' },
    { id: 'LineDetails', label: 'Line Details', parent: 'Lines' },
    { id: 'ProductReceiptDetails', label: 'Receipt Details', parent: '' },
    { id: 'FreightChargeDetails', label: 'Freight Charge Details', parent: '' }
];
